module.exports = __webpack_public_path__ + "static/media/oneday_6.574850b0.png";